var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3H2C0.9 3 0 3.9 0 5V21C0 22.1 0.9 23 2 23H24C25.1 23 26 22.1 26 21V5C26 3.9 25.1 3 24 3ZM25 21C25 21.55 24.55 22 24 22H2C1.45 22 1 21.55 1 21V5C1 4.45 1.45 4 2 4H24C24.55 4 25 4.45 25 5V21Z",
    fill: "#D0D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9H10.5C10.78 9 11 8.78 11 8.5C11 8.22 10.78 8 10.5 8H5.5C5.22 8 5 8.22 5 8.5C5 8.78 5.22 9 5.5 9Z",
    fill: "#D0D0D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8H15.5C15.22 8 15 8.22 15 8.5C15 8.78 15.22 9 15.5 9H20.5C20.78 9 21 8.78 21 8.5C21 8.22 20.78 8 20.5 8Z",
    fill: "#D0D0D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11H5.5C5.22 11 5 11.22 5 11.5C5 11.78 5.22 12 5.5 12H20.5C20.78 12 21 11.78 21 11.5C21 11.22 20.78 11 20.5 11Z",
    fill: "#D0D0D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15H7.5C7.37 15 7.24 15.05 7.15 15.15C7.06 15.24 7 15.37 7 15.5V18.5C7 18.63 7.05 18.76 7.15 18.85C7.24 18.94 7.37 19 7.5 19H18.5C18.63 19 18.76 18.95 18.85 18.85C18.94 18.76 19 18.63 19 18.5V15.5C19 15.37 18.95 15.24 18.85 15.15C18.76 15.06 18.63 15 18.5 15ZM8 16H18V18H8V16Z",
    fill: "#D0D0D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/Container.1c0ff82c322860d14a1da48f89d7abea.svg";
export { ForwardRef as ReactComponent };